import { setCurrentFinanceYear } from "@/redux/slices";
import { RootState } from "@/redux/store";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const useDashboard = () => {
  const dispatch = useDispatch();
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  const currentFinanceYear = useSelector(
    (state: RootState) => state.currentData.currentFinanceYear
  );

  useEffect(() => {
    if (!currentFinanceYear) {
      dispatch(setCurrentFinanceYear(String(moment().year())));
    }
  }, []);

  return {
    currentFinanceYear,
    loggedInUserData,
  };
};

export default useDashboard;
